// @ts-nocheck
import { type ClassValue, clsx } from "clsx"

export function cn(...inputs: ClassValue[]) {
  // Simple className merger - use clsx only
  // tailwind-merge is optional and not installed to reduce bundle size
  return clsx(inputs)
}
